import React from "react";
import RNavbar from "../component/RNavbar";
import "./Service.css";
import { LazyLoadImage } from "react-lazy-load-image-component";

import RFooter from "../component/RFooter";
import Calculator from "../component/Calculator";

import s3 from "../img/howWeWork/t1.png";
import sqs3 from "../img/howWeWork/sqt1.png";

/**/

import support from "../img/howWeWork/customerSupport.png";
import sqsupport from "../img/howWeWork/sqcustomerSupport.png";

import paper from "../img/howWeWork/paperSupport.png";
import sqpaper from "../img/howWeWork/sqpaperSupport.png";

import plag from "../img/howWeWork/plaigarism.png";
import sqplag from "../img/howWeWork/sqplaigarism.png";

import researchi from "../img/howWeWork/research.png";
import sqresearchi from "../img/howWeWork/sqresearch.png";

import article from "../img/howWeWork/article.png";
import sqarticle from "../img/howWeWork/sqarticle.png";

import faster from "../img/howWeWork/faster.png";
import sqfaster from "../img/howWeWork/sqfaster.png";

import degree from "../img/howWeWork/degree.png";
import sqdegree from "../img/howWeWork/sqdegree.png";

import secure from "../img/howWeWork/secure.png";
import sqsecure from "../img/howWeWork/sqsecure.png";

import timely from "../img/howWeWork/timely.png";
import sqtimely from "../img/howWeWork/sqtimely.png";

import anon from "../img/howWeWork/anon.png";
import sqanon from "../img/howWeWork/sqanon.png";

import money from "../img/howWeWork/money.png";
import sqmoney from "../img/howWeWork/sqmoney.png";

import Connect from "../component/Connect";

function Services() {
  window.scrollTo(0, 0);

  return (
    <div className="m-service-page">
      <RNavbar main="mservice-p-head" />
      <Connect />
      <div className="mservice-p-head">
        <h1>Our Services</h1>
        <p>
          My desktop publishing packages and web page editors now use.Many
          desktop publishing packages and web page editors now use
        </p>
      </div>
      <div className="mservice-c">
        <div className="service-list">
          <div className="srm">
            <div className="srm-img">
              <LazyLoadImage
                alt="service"
                effect="blur"
                src={researchi}
                placeholderSrc={sqresearchi}
                width="160px"
                height="160px"
              />
            </div>
            <div className="srm-text">
              <h2>Research proposals</h2>
              <p>
                What you intend to do in your research study, what will be the
                final outcome based on the tittle of your research study. Have
                confusions get is addressed
              </p>
            </div>
          </div>
          <div className="srm">
            <div className="srm-text">
              <h2>Article writing</h2>
              <p>
                Any refrencing or citation work, for instance literatutre review
                for a specific topic is not available, we would try and help you
                get relevant content for your research subject.
              </p>
            </div>

            <div className="srm-img">
              <LazyLoadImage
                alt="service"
                effect="blur"
                src={article}
                placeholderSrc={sqarticle}
                width="160px"
                height="160px"
              />
            </div>
          </div>
          <div className="srm">
            <div className="srm-img">
              <LazyLoadImage
                alt="service"
                effect="blur"
                src={s3}
                placeholderSrc={sqs3}
                width="160px"
                height="160px"
              />
            </div>
            <div className="srm-text">
              <h2>Thesis writing</h2>
              <p>
                caught up or too busy for Phd completion, we have professionals
                who will draft your research work
              </p>
            </div>
          </div>
          <div className="srm">
            <div className="srm-text">
              <h2>Assignment support in computer science</h2>
              <p>
                From programming help and code implementation to all you
                computer science folks, if prototypes and final outcomes are
                pending we've got your back. It need not necesarily be
                \prototypes, it could be anything that you struggling with to
                implemnt.
              </p>
            </div>
            <div className="srm-img">
              <LazyLoadImage
                alt="service"
                effect="blur"
                src={support}
                placeholderSrc={sqsupport}
                width="160px"
                height="160px"
              />
            </div>
          </div>

          <div className="srm">
            <div className="srm-img">
              <LazyLoadImage
                alt="service"
                effect="blur"
                src={plag}
                placeholderSrc={sqplag}
                width="160px"
                height="160px"
              />
            </div>
            <div className="srm-text">
              <h2>Plagiarism free work</h2>
              <p>
                we will ensure that genuine & authentic work is done for you.
                Our work will be neat, it will exceed your expectation and there
                will not be any comprimise on quality of work done. You will get
                good quality content along with results.
              </p>
            </div>
          </div>

          <div className="srm">
            <div className="srm-text">
              <h2>Assignment support in Management</h2>
              <p>
                Be it Phd in finance, marketing, Human resources etc, We're
                here. we have experts who will help you with good quality
                research work.
              </p>
            </div>
            <div className="srm-img">
              <LazyLoadImage
                alt="service"
                effect="blur"
                src={paper}
                placeholderSrc={sqpaper}
                width="160px"
                height="160px"
              />
            </div>
          </div>
        </div>

        <div className="feature-c">
          <div className="feature-heading">
            <h1>Features</h1>
            <p>We are best at it</p>
          </div>
          <div className="features">
            <div>
              <LazyLoadImage
                alt="feature"
                effect="blur"
                src={faster}
                placeholderSrc={sqfaster}
                width="140px"
                height="140px"
              />
              <p>Faster Delivery</p>
            </div>
            <div>
              <LazyLoadImage
                alt="feature"
                effect="blur"
                src={degree}
                placeholderSrc={sqdegree}
                width="140px"
                height="140px"
              />
              <p>Degreed writers</p>
            </div>
            <div>
              <LazyLoadImage
                alt="feature"
                effect="blur"
                src={secure}
                placeholderSrc={sqsecure}
                width="140px"
                height="140px"
              />
              <p>Secure payment</p>
            </div>
            <div>
              <LazyLoadImage
                alt="feature"
                effect="blur"
                src={timely}
                placeholderSrc={sqtimely}
                width="140px"
                height="140px"
              />
              <p>Timely delivery</p>
            </div>
            <div>
              <LazyLoadImage
                alt="feature"
                effect="blur"
                src={money}
                placeholderSrc={sqmoney}
                width="140px"
                height="140px"
              />
              <p>Money-back guarantee</p>
            </div>
            <div>
              <LazyLoadImage
                alt="feature"
                effect="blur"
                src={anon}
                placeholderSrc={sqanon}
                width="140px"
                height="140px"
              />
              <p>100% anonymity</p>
            </div>
          </div>
        </div>
      </div>
      <div className="hwork-calc">
        <Calculator />
      </div>

      <RFooter />
    </div>
  );
}

export default Services;
